import { Component, Fragment } from 'react';
import styled from 'styled-components';

import { pcVisitedLink } from '../../../../../common/css/setting/mixin';
import ModuleTitle from '../modules/ModuleTitle';
import {
  HeaderStyle,
  HeadingStyle,
  HeadingTitleStyle,
  SportsNavStyle,
  SportsNavItemStyle,
  SportsBodyStyle,
  SportsListStyle
} from './sportsCommonStyle';
import BaseballGame from './BaseballGame';
import BaseballPlayer from './BaseballPlayer';

interface IProps {
  npb: {
    isShow: boolean;
    games?: Array<{
      url: string;
      teamHome: string;
      teamVisitor: string;
    }>;
    date?: string;
  };
  mlb: {
    isShow: boolean;
    players?: Array<{
      url: string;
      name: string;
    }>;
    date?: string;
  };

  hasTitle: boolean; // モジュールタイトルを表示する
}

const Header = styled.div<{ $hasTitle: boolean }>`
  ${HeaderStyle}
`;

const Heading = styled.div`
  ${HeadingStyle}
`;

const HeadingTitle = styled.div`
  ${HeadingTitleStyle}
`;

const HeadingTimeStamp = styled.div`
  margin-left: 8px;
  color: ${props => props.theme.news.palette.text_sub_lv2_common};
`;

const NavList = styled.ul`
  ${SportsNavStyle}
`;

const NavItem = styled.li`
  ${SportsNavItemStyle}
`;

const NavLink = styled.a`
  ${pcVisitedLink}
`;

const Body = styled.div`
  ${SportsBodyStyle}
`;

const List = styled.ul`
  ${SportsListStyle}
`;

export default class Baseball extends Component<IProps> {
  /**
   *
   */
  public render() {
    // NPBとMLBどちらもない場合はモジュールは空
    if (!this.props.npb.isShow && !this.props.mlb.isShow) {
      return null;
    }
    const npbHeader = this.props.npb.isShow ? (
      <Header $hasTitle={this.props.hasTitle}>
        <Heading>
          <HeadingTitle>スポーツナビ プロ野球 試合結果</HeadingTitle>
          <HeadingTimeStamp>{this.props.npb.date || ''}</HeadingTimeStamp>
        </Heading>
        <NavList>
          <NavItem>
            <NavLink href="https://baseball.yahoo.co.jp/npb/" data-cl-params="_cl_vmodule:npb;_cl_link:ysports;">
              プロ野球トップ
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="https://baseball.yahoo.co.jp/npb/schedule/" data-cl-params="_cl_vmodule:npb;_cl_link:sche;">
              日程・結果
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="https://baseball.yahoo.co.jp/npb/standings/"
              data-cl-params="_cl_vmodule:npb;_cl_link:stdngs;"
            >
              順位表
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="https://baseball.yahoo.co.jp/npb/stats/" data-cl-params="_cl_vmodule:npb;_cl_link:stats;">
              個人成績
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="https://baseball.yahoo.co.jp/npb/teams/" data-cl-params="_cl_vmodule:npb;_cl_link:teams;">
              チーム
            </NavLink>
          </NavItem>
        </NavList>
      </Header>
    ) : null;

    const npbBody = this.props.npb.isShow ? (
      <Body>
        <List>
          {this.props.npb.games
            ? this.props.npb.games.map((game, index) => {
                return (
                  <BaseballGame
                    {...game}
                    key={game.url}
                    dataClParams={`_cl_vmodule:npb;_cl_link:game;_cl_position:${index + 1};`}
                  />
                );
              })
            : null}
        </List>
      </Body>
    ) : null;
    const mlbHeader = this.props.mlb.isShow ? (
      <Header $hasTitle={this.props.hasTitle}>
        <Heading>
          <HeadingTitle>スポーツナビ MLB 日本人選手出場試合</HeadingTitle>
          <HeadingTimeStamp>{this.props.mlb.date || ''}</HeadingTimeStamp>
        </Heading>
        <NavList>
          <NavItem>
            <NavLink href="https://baseball.yahoo.co.jp/mlb/" data-cl-params="_cl_vmodule:mlb;_cl_link:ysports;">
              MLBトップ
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="https://baseball.yahoo.co.jp/mlb/schedule/" data-cl-params="_cl_vmodule:mlb;_cl_link:sche;">
              日程・結果
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="https://baseball.yahoo.co.jp/mlb/standings/"
              data-cl-params="_cl_vmodule:mlb;_cl_link:stdngs;"
            >
              順位表
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="https://baseball.yahoo.co.jp/mlb/stats/" data-cl-params="_cl_vmodule:mlb;_cl_link:stats;">
              個人成績
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="https://baseball.yahoo.co.jp/mlb/teams/" data-cl-params="_cl_vmodule:mlb;_cl_link:teams;">
              チーム
            </NavLink>
          </NavItem>
        </NavList>
      </Header>
    ) : null;

    const mlbBody = this.props.mlb.isShow ? (
      <Body>
        <List>
          {this.props.mlb.players
            ? this.props.mlb.players.map((player, index) => {
                return (
                  <BaseballPlayer
                    {...player}
                    key={`${player.url}#${index}`}
                    dataClParams={`_cl_vmodule:mlb;_cl_link:player;_cl_position:${index + 1};`}
                  />
                );
              })
            : null}
        </List>
      </Body>
    ) : null;

    return (
      <Fragment>
        {this.props.hasTitle ? <ModuleTitle titleText="野球情報" hasPayPay={false} /> : ``}
        {/* NOTE: ここ作りにくいのでHTMLの構成変えています */}
        {npbHeader}
        {npbBody}
        {mlbHeader}
        {mlbBody}
      </Fragment>
    );
  }
}
